import React from 'react';
import PropTypes from 'prop-types';
import LeadersHero from './StatsLeadersHero';
import StatsLeadersRow from './StatsLeadersRow';
import Loader from '../../Loader';

export default function StatsLeaders({ type, data }) {
  const isTeam = type.includes('team');

  if (data?.length > 0) {
    return (
      <div className="d-flex stats-table">
        <div className="flex-grow-1">
          <div className="col-8 mx-auto">
            <LeadersHero data={data[0]} type={type} />
          </div>
          {data?.map((row) => (
            <StatsLeadersRow
              key={`${row.fogisId}_${type}`}
              data={row}
              stat={row[type]}
              type={type}
            />
          ))}
          <div className="flex-grow-1 mt-3 mb-3 px-2">
            <a
              className="button button--primary-blue button--large d-block text-center"
              href={isTeam ? '/statistik/lag' : '/statistik/spelare'}
            >
              SE MER
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (data?.length === 0) return <Loader />;
}

StatsLeaders.propTypes = {
  type: PropTypes.string.isRequired,
};
